import * as React from "react";
import { singleton } from "../logic/singleton";
export const defaultUserPreferences = {
  enableSmartSearch: true,
  updateUnfocussed: false,
  searchSidebarIsPinned: false,
  dashboardSidebarIsPinned: false
};
const UserPreferencesContext = React.createContext(defaultUserPreferences);
export default singleton("contexts.UserPreferencesContext", () => UserPreferencesContext);
